var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { _PdfDecodeStream } from '../decode-stream';
var _PdfJpxStream = /** @class */ (function (_super) {
    __extends(_PdfJpxStream, _super);
    function _PdfJpxStream(stream, maybeLength, params) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.maybeLength = maybeLength;
        _this.params = params;
        return _this;
    }
    Object.defineProperty(_PdfJpxStream.prototype, "bytes", {
        get: function () {
            return this.stream.getBytes(this.maybeLength);
        },
        enumerable: true,
        configurable: true
    });
    _PdfJpxStream.prototype.readBlock = function () {
        throw new Error('JpxStream.readBlock');
    };
    Object.defineProperty(_PdfJpxStream.prototype, "isAsyncDecoder", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    _PdfJpxStream.prototype.decodeImage = function (bytes) {
        if (this.eof) {
            return this.buffer;
        }
        bytes = bytes || this.bytes;
        this.eof = true;
        return bytes;
    };
    Object.defineProperty(_PdfJpxStream.prototype, "canAsyncDecodeImageFromBuffer", {
        get: function () {
            return this.stream.isAsync;
        },
        enumerable: true,
        configurable: true
    });
    return _PdfJpxStream;
}(_PdfDecodeStream));
export { _PdfJpxStream };
